import { ApiRoutes } from "../common/apiRoutes";
import Http from "../services/http";

export const loginUserAPI = (data: any) => {
  return Http.post(ApiRoutes.login, data);
};

export const forgotPasswordAPI = (data: any) => {
  return Http.post(ApiRoutes.forgotPassword, data);
};

export const linkExpiredAPI = (data: any) => {
  return Http.post(ApiRoutes.linkExpired, data);
};

export const resetPasswordAPI = (data: any) => {
  return Http.post(ApiRoutes.resetPassword, data);
};